import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgClosed = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 66 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M13.726 27.225 29.474 1.116 52.713 23.08"
      stroke="#263238"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.525 17.58 1.027 25.157 4.996 56.85l60.497-7.576-3.968-31.693Z"
      fill="#16796F"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.928 46.828a3.27 3.27 0 0 1-2.648 1.551 3.35 3.35 0 0 1-3.017-.912A6.16 6.16 0 0 1 8.808 43.9l-.94-7.511c-.322-2.567.14-4.254 1.382-5.061a4.19 4.19 0 0 1 1.76-.583c2.422-.304 3.825 1.083 4.208 4.139l.297 2.371-2.54.319-.277-2.213a5.88 5.88 0 0 0-.457-1.878.88.88 0 0 0-.954-.455.91.91 0 0 0-.837.72 5.132 5.132 0 0 0-.026 1.887l1.008 8.047c.047.676.215 1.338.496 1.954a.89.89 0 0 0 .968.483.9.9 0 0 0 .817-.717 6.062 6.062 0 0 0-.01-2.014l-.31-2.47 2.58-.324.31 2.48a6.23 6.23 0 0 1-.356 3.754ZM19.09 47.466l-2.16-17.255 2.63-.33 1.88 15.013 3.323-.416.281 2.243-5.954.745ZM32.842 44.675a3.34 3.34 0 0 1-2.732 1.602 3.42 3.42 0 0 1-3.063-.876 6.41 6.41 0 0 1-1.405-3.654l-.988-7.889c-.396-3.165.705-4.915 3.285-5.238a3.351 3.351 0 0 1 3.03.85 6.1 6.1 0 0 1 1.316 3.433l.988 7.888a6.47 6.47 0 0 1-.431 3.884Zm-4.054-1.145a.93.93 0 0 0 1.067.47.89.89 0 0 0 .856-.731 6.51 6.51 0 0 0-.034-2.122l-1.007-8.038a5 5 0 0 0-.453-1.767.88.88 0 0 0-.972-.443 1 1 0 0 0-.923.68 4.46 4.46 0 0 0-.044 1.82l1.007 8.047c.057.717.227 1.42.503 2.084ZM35.292 40.505l-.192-1.538 2.49-.312.217 1.726c.048.676.216 1.337.496 1.954a.9.9 0 0 0 .996.47.89.89 0 0 0 .834-.589 4.002 4.002 0 0 0 .022-1.595 4.37 4.37 0 0 0-.625-1.846 6.77 6.77 0 0 0-1.452-1.542l-1.444-1.15a8.002 8.002 0 0 1-1.632-1.76 5.22 5.22 0 0 1-.785-2.25 5.14 5.14 0 0 1 .425-3.278 3.46 3.46 0 0 1 2.708-1.398 2.91 2.91 0 0 1 2.87.87 7.142 7.142 0 0 1 1.158 3.453l.143 1.141-2.411.302-.154-1.23a5.539 5.539 0 0 0-.445-1.779.82.82 0 0 0-.9-.431 1.001 1.001 0 0 0-.822.516 2.23 2.23 0 0 0-.123 1.275c.04.455.191.893.442 1.275.337.42.723.797 1.149 1.126l1.611 1.36a9.06 9.06 0 0 1 1.9 2.14 6.14 6.14 0 0 1 .87 2.522 6.32 6.32 0 0 1-.364 3.684 3.27 3.27 0 0 1-2.704 1.508 3.08 3.08 0 0 1-2.99-.936 7.18 7.18 0 0 1-1.288-3.688ZM45.126 44.2l-2.161-17.255 5.785-.724.283 2.262-3.106.39.629 5.02 2.977-.373.277 2.213-2.977.373.688 5.497 3.275-.41.283 2.262-5.953.746ZM53.115 43.206l-2.16-17.256 3.87-.484a3.28 3.28 0 0 1 2.898.776 5.43 5.43 0 0 1 1.279 3.206l.974 7.779a6.74 6.74 0 0 1-.385 3.928 3.28 3.28 0 0 1-2.705 1.578l-3.77.473Zm2.374-2.374.863-.108a1.22 1.22 0 0 0 .994-.598 3.27 3.27 0 0 0 .11-1.767l-1.066-8.524a4.07 4.07 0 0 0-.566-1.864 1.21 1.21 0 0 0-1.202-.424l-.784.098 1.651 13.187Z"
      fill="#fff"
    />
  </svg>
);
export default SvgClosed;
